// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'
import './exam.scss'
import myConfig from './config.js'
// // import $ from 'jquery'

import myI18n from './components/I18N/i18n.js'
import Vuex from 'vuex'
import API from './api.js'
import APIADMIN from './admin.js'
import APISYSTEM from './apiSystem.js'
import APILDAP from './apiLDAP.js'
import APIParticipant from './apiParticipant.js'
import APIStorage from './storage.js'
import APISASExt from './sasExt.js'
import vuexI18n from 'vuex-i18n'
import VueKatex from 'vue-katex'
import './stylus/main.styl'
import '../node_modules/roboto-fontface/css/roboto/roboto-fontface.css'
import '../node_modules/material-icons-font/material-icons-font.css'
import 'sweetalert2/src/sweetalert2.scss'
import 'katex/dist/katex.min.css'
Vue.config.HOST = myConfig.HOST
Vue.use(Vuex)
const store = new Vuex.Store()
Vue.use(vuexI18n.plugin, store)
Vue.use(Vuetify, {
  theme: {
    primary: '#808080',
    secondary: '#424242',
    accent: '#FFFFFF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    examenis: '#043073',
    examenishell: '#e5f4fe',
    examenisDisabled: '#4d5a79'
  }
})
Vue.use(VueKatex)
// window.$ = require('jquery')
Vue.prototype.$eventHub = new Vue() // Global event bus
Vue.config.productionTip = false
// Vue.config.host = 'http://localhost:9000'
// Vue.config.host = 'http://193.175.17.10:8080' // Examenis Kiel
Vue.config.host = myConfig.HOST // Examenis FWS Bruchsal
Vue.use(myI18n)
Vue.prototype.$config = myConfig
Vue.prototype.$api = API
Vue.prototype.$apiAdmin = APIADMIN
Vue.prototype.$apiParticipant = APIParticipant
Vue.prototype.$apiSystem = APISYSTEM
Vue.prototype.$sasExt = APISASExt
Vue.prototype.$storage = APIStorage
Vue.prototype.$APILDAP = APILDAP
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js